import { ContentCopy } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

import { useCopyToClipboard } from '@hooks/useCopyToClipboard';

interface CopyIconButtonProps {
  /** The value written to the clipboard. Renders nothing when empty. */
  value: string | null | undefined;
  /** What is being copied, e.g. "User ID". Drives the tooltip and the toast. */
  label: string;
  fontSize?: number;
}

/**
 * The `Tooltip` + `IconButton` + `ContentCopy` trio, which the admin views
 * otherwise hand-roll at every field that exposes an ID.
 */
export function CopyIconButton({ value, label, fontSize = 14 }: CopyIconButtonProps) {
  const copy = useCopyToClipboard();

  if (!value) return null;

  return (
    <Tooltip title={`Copy ${label}`}>
      <IconButton size="small" aria-label={`Copy ${label}`} onClick={() => copy(value, label)}>
        <ContentCopy sx={{ fontSize }} />
      </IconButton>
    </Tooltip>
  );
}
